import * as React from 'react';
import { formatMonthName, OwaDate } from 'owa-datetime';
import { observer } from 'mobx-react-lite';
import { ActionButton } from '@fluentui/react/lib/Button';
import { Icon } from '@fluentui/react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';

const classNames = require('classnames');
const styles = require('./CalendarPaneHeaderTimestrip.scss');

export default observer(function CalendarPaneHeaderTimestrip({
    date,
    onClick,
    textFormatter,
    customTooltip,
    ariaExpanded,
}: {
    date: OwaDate;
    onClick?: () => void;
    textFormatter?: (date: OwaDate) => string;
    customTooltip?: string;
    ariaExpanded?: boolean;
}) {
    const dateText = textFormatter ? textFormatter(date) : formatMonthName(date);

    return onClick ? (
        <ActionButton
            className={classNames(styles.dayAndMonth, styles.timestrip)}
            title={customTooltip ? customTooltip : dateText}
            onClick={onClick}
            aria-expanded={ariaExpanded}>
            <div className={styles.buttonLabel}>
                <div className={styles.buttonLabelText}>{dateText}</div>
                <Icon iconName={ControlIcons.ChevronDown} />
            </div>
        </ActionButton>
    ) : (
        <div className={styles.dayAndMonth} title={dateText}>
            {dateText}
        </div>
    );
});
